<template>
  <LeadHistoryCard
    v-model:pick-up-call-target-id="pickUpCallTargetId"
    :text="actionTypeText"
    toggle
    :expand="expand"
    is-boxil-event
    icon="assignment"
    icon-type="boxil"
    :call-target-id="callTargetId"
    :call-target="callTarget"
    :history="boxilLeadSurvey"
  >
    <template #date>
      <div>{{ historiedAt }}</div>
    </template>
    <BListItem>
      <template #header>
        <div>{{ $t('boxilLeadSurvey.history.problems') }}</div>
      </template>
      <span>{{ boxilLeadSurvey.problems }}</span>
    </BListItem>
    <BListItem class="mt-400">
      <template #header>
        <div>{{ $t('boxilLeadSurvey.history.introductionTime') }}</div>
      </template>
      <span>{{ boxilLeadSurvey.introductionTime }}</span>
    </BListItem>
    <BListItem class="mt-400">
      <template #header>
        <div>{{ $t('boxilLeadSurvey.history.tools') }}</div>
      </template>
      <span>{{ boxilLeadSurvey.tools }}</span>
    </BListItem>
  </LeadHistoryCard>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import type { CallTarget, HistoryCommon } from '@/api/openapi';
import LeadHistoryCard from '@/components/organisms/user/lead/history/LeadHistoryCard.vue';
import { formatShorterDateTime } from '@/utils/date-time';

type TProps = {
  callTargetId: number;
  boxilLeadSurvey: HistoryCommon & {
    historiedAt: string;
    actionTypeText: string;
    problems: string;
    introductionTime: string;
    tools: string;
  };
  callTarget?: CallTarget;
  expand?: boolean;
}

const props = defineProps<TProps>();
defineOptions({
  inheritAttrs: false,
});

// v-model for pickUpCallTargetId to pass through to parent
const pickUpCallTargetId = defineModel<number>('pickUpCallTargetId');

const historiedAt = computed(() => {
  return formatShorterDateTime(props.boxilLeadSurvey.historiedAt);
});

const actionTypeText = computed(() => {
  return props.boxilLeadSurvey.actionTypeText;
});
</script>
